<template>
  <v-overlay v-model="show" :absolute="true"
    z-index="998" :opacity="0.8" :dark="$vuetify.theme.dark">
    <v-card>
      <v-card-text v-if="group">
        <div v-if="archived" v-html="$t('chat.messageOverlay.archived', { roomName: group.formatName() })" />
      </v-card-text>
      <v-card-actions v-if="archived">
        <v-spacer/>
          <v-btn text v-if="$vuetify.breakpoint.mobile"
            @click="$emit('open-menu')">
            {{ $t('chat.openMenu') }}
          </v-btn>
          <v-spacer />
          <v-btn text color="primary"
            v-if="group.isOwner()"
            @click="submitRestore()">
            {{ $t('chat.contextMenu.restore') }}
          </v-btn>
      </v-card-actions>
    </v-card>
  </v-overlay>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'chat-groups-message-overlay',
  computed: {
    ...mapGetters({
      currentUser: 'chat/authenticatedRocketChatUser',
      groups: 'chat/groups'
    }),

    group () {
      if (this.$route?.params.roomType === 'group') {
        return this.groups.find(group => group.id === this.$route?.params?.roomId)
      }
      return null
    },

    selected () {
      return this.$route?.params.roomType === 'group' &&
        this.$route?.params?.roomId === this.group?.id
    },

    archived () {
      return this.group?.archived
    },

    show () {
      return this.selected && this.archived
    }
  },
  methods: {
    ...mapActions({
      restore: 'chat/restoreGroup',
      setContextMenuGroup: 'chat/setContextMenuGroup'
    }),

    submitRestore () {
      this.setContextMenuGroup(this.group)
      this.restore()
    }
  }
}
</script>

<style>
</style>
